<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>Supermercados</h6>
             <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
         <p class="text-sm mb-0">
           <span class="font-weight-bold">{{ supermercados.length }}</span> supermercados encontrados
         </p>
         <div class="d-flex flex-wrap gap-2">
           <button 
             @click="showAddModal"
             class="btn btn-sm btn-custom-gradient"
           >
             Adicionar
           </button>
           <button 
             @click="loadSupermercados" 
             class="btn btn-sm"
             :class="loading ? 'btn-secondary' : 'btn-custom-gradient'"
             :disabled="loading"
           >
            {{ loading ? 'Carregando...' : 'Atualizar' }}
          </button>
         </div>
       </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div v-if="error" class="alert alert-danger mx-3">
        {{ error }}
      </div>
             <div v-if="loading" class="text-center py-4">
         <div class="spinner-border spinner-teal" role="status">
           <span class="visually-hidden">Carregando...</span>
         </div>
       </div>
      <div v-else class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Nome
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Endereço
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                CNPJ
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Status
              </th>
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="supermercado in supermercados" :key="supermercado.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ supermercado.nome || supermercado.name }}</h6>
                    <p class="text-xs text-secondary mb-0">
                      ID: {{ supermercado.id }}
                    </p>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center">
                <div class="d-flex gap-2 justify-content-center">
                  <button
                    @click="showAddress(supermercado.id)"
                    class="btn btn-sm btn-address-gradient"
                    :disabled="loadingAddress"
                  >
                    <i class="fas fa-map-marker-alt me-1"></i>
                    Ver Endereço
                  </button>
                  <button
                    @click="openEditAddressModal(supermercado)"
                    class="btn btn-sm btn-edit-address"
                  >
                    <i class="fas fa-pencil-alt me-1"></i>
                    Editar
                  </button>
                </div>
             </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">
                  {{ supermercado.cnpj || supermercado.CNPJ || 'N/A' }}
                </span>
              </td>
              <td class="align-middle text-center text-sm">
                <soft-badge 
                  :color="getStatusColor(supermercado.status || supermercado.ativo)" 
                  variant="gradient" 
                  size="sm"
                >
                  {{ getStatusText(supermercado.status || supermercado.ativo) }}
                </soft-badge>
              </td>
              <td class="align-middle">
                <div class="d-flex align-items-center justify-content-end gap-2 pe-3">
                  <a
                    href="javascript:;"
                    class="text-secondary font-weight-bold text-xs"
                    data-toggle="tooltip"
                    data-original-title="Ver detalhes"
                    @click="viewDetails(supermercado)"
                  >
                    Detalhes
                  </a>
                  <a
                    href="javascript:;"
                    class="text-danger"
                    data-toggle="tooltip"
                    data-original-title="Desativar supermercado"
                    @click="deactivateSupermarket(supermercado)"
                    title="Desativar supermercado"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </a>
                </div>
              </td>
            </tr>
            <tr v-if="supermercados.length === 0 && !loading">
              <td colspan="5" class="text-center py-4">
                <p class="text-secondary">Nenhum supermercado encontrado</p>
              </td>
            </tr>
          </tbody>
        </table>
             </div>
     </div>
       </div>

    <!-- Modal de Endereço -->
    <div v-if="showModal" class="modal-backdrop fade show" @click="closeModal" style="z-index: 9999;"></div>
    <div v-if="showModal" class="modal fade show d-block" tabindex="-1" aria-labelledby="addressModalLabel" aria-hidden="true" style="z-index: 10000;">
      <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addressModalLabel">
              <i class="fas fa-map-marker-alt me-2"></i>
              Endereço do Supermercado
            </h5>
            <button type="button" class="btn-close" @click="closeModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="loadingAddress" class="text-center py-4">
              <div class="spinner-border spinner-teal" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-2">Carregando endereço...</p>
            </div>
            <div v-else-if="addressError" class="alert alert-danger">
              {{ addressError }}
            </div>
            <div v-else-if="addressData">
              <div class="row">
                <div class="col-12">
                  <h6 class="text-primary mb-3">{{ addressData.nome || addressData.name }}</h6>
                  <div class="address-details">
                    <p class="mb-2">
                      <strong>Endereço:</strong><br>
                      {{ addressData.address || 'N/A' }}, {{ addressData.number || 'N/A' }}
                    </p>
                    <p class="mb-2">
                      <strong>Cidade:</strong> {{ addressData.cidade || addressData.city || ' ' }}
                    </p>
                    <p class="mb-2">
                      <strong>Estado:</strong> {{ addressData.estado || addressData.state || ' ' }}
                    </p>
                    <p class="mb-2">
                      <strong>CEP:</strong> {{ addressData.zipcode || ' ' }}
                    </p>
                    <p class="mb-2">
                      <strong>Bairro:</strong> {{ addressData.bairro || addressData.neighborhood || ' ' }}
                    </p>
                    <p class="mb-0">
                      <strong>Complemento:</strong> {{ addressData.address_line_2 || ' ' }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Editar Endereço -->
    <div v-if="showEditAddressModal" class="modal-backdrop fade show" @click="closeEditAddressModal" style="z-index: 9999;"></div>
    <div v-if="showEditAddressModal" class="modal fade show d-block" tabindex="-1" aria-labelledby="editAddressModalLabel" aria-hidden="true" style="z-index: 10000;">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editAddressModalLabel">
              <i class="fas fa-map-marker-alt me-2"></i>
              {{ editAddressMode === 'create' ? 'Adicionar Endereço' : 'Editar Endereço' }}
            </h5>
            <button type="button" class="btn-close" @click="closeEditAddressModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="loadingEditAddress" class="text-center py-4">
              <div class="spinner-border spinner-teal" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-2">Carregando endereço...</p>
            </div>
            <div v-else>
              <div v-if="editAddressError" class="alert alert-danger mb-3">
                {{ editAddressError }}
              </div>
              <form @submit.prevent="saveAddress">
                <div class="mb-3">
                  <label class="form-label">CEP *</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="editAddressForm.zipcode"
                    placeholder="Ex: 01310-100"
                  />
                </div>
                <div class="mb-3">
                  <label class="form-label">Número *</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="editAddressForm.number"
                    placeholder="Ex: 123"
                  />
                </div>
                <div class="mb-3">
                  <label class="form-label">Complemento</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="editAddressForm.address_line_2"
                    placeholder="Ex: Apto 4, Bloco B"
                  />
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeEditAddressModal">Cancelar</button>
            <button
              type="button"
              class="btn btn-custom-gradient"
              @click="saveAddress"
              :disabled="savingAddress || loadingEditAddress || !editAddressForm.zipcode || !editAddressForm.number"
            >
              <span v-if="savingAddress">
                <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                Salvando...
              </span>
              <span v-else>
                <i class="fas fa-save me-1"></i>
                {{ editAddressMode === 'create' ? 'Cadastrar' : 'Salvar' }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Adicionar Supermercado -->
     <div v-if="showAddSupermarketModal" class="modal-backdrop fade show" @click="closeAddModal" style="z-index: 9999;"></div>
     <div v-if="showAddSupermarketModal" class="modal fade show d-block" tabindex="-1" aria-labelledby="addSupermarketModalLabel" aria-hidden="true" style="z-index: 10000;">
       <div class="modal-dialog modal-dialog-centered modal-lg">
         <div class="modal-content">
           <div class="modal-header">
             <h5 class="modal-title" id="addSupermarketModalLabel">
               <i class="fas fa-plus me-2"></i>
               Adicionar Novo Supermercado
             </h5>
             <button type="button" class="btn-close" @click="closeAddModal" aria-label="Close"></button>
           </div>
           <div class="modal-body">
             <div v-if="loadingAdd" class="text-center py-4">
               <div class="spinner-border spinner-teal" role="status">
                 <span class="visually-hidden">Carregando...</span>
               </div>
               <p class="mt-2">Cadastrando supermercado...</p>
             </div>
             <div v-else-if="addError" class="alert alert-danger">
               {{ addError }}
             </div>
             <div v-else>
               <form @submit.prevent="addSupermarket">
                 <div class="row">
                   <div class="col-12 mb-3">
                     <label for="supermarketName" class="form-label">Nome do Supermercado *</label>
                     <input 
                       type="text" 
                       class="form-control" 
                       id="supermarketName"
                       v-model="newSupermarket.name"
                       placeholder="Ex: Atacadão Parelheiros"
                       required
                     >
                   </div>
                   <div class="col-12 mb-3">
                     <label for="supermarketCnpj" class="form-label">CNPJ</label>
                     <input 
                       type="text" 
                       class="form-control" 
                       id="supermarketCnpj"
                       v-model="newSupermarket.cnpj"
                       placeholder="Ex: 75.315.333/0057-63"
                     >
                   </div>
                   <div class="col-12 mb-3">
                     <label for="supermarketZipcode" class="form-label">CEP *</label>
                     <input 
                       type="text" 
                       class="form-control" 
                       id="supermarketZipcode"
                       v-model="newSupermarket.zipcode"
                       placeholder="Ex: 04864-002"
                       required
                     >
                   </div>
                   <div class="col-12 mb-3">
                     <label for="supermarketNumber" class="form-label">Número *</label>
                     <input 
                       type="text" 
                       class="form-control" 
                       id="supermarketNumber"
                       v-model="newSupermarket.number"
                       placeholder="Ex: 8030"
                       required
                     >
                   </div>
                 </div>
               </form>
             </div>
           </div>
           <div class="modal-footer">
             <button type="button" class="btn btn-secondary" @click="closeAddModal">Cancelar</button>
             <button 
               type="button" 
               class="btn btn-custom-gradient" 
               @click="addSupermarket"
               :disabled="loadingAdd || !newSupermarket.name || !newSupermarket.zipcode || !newSupermarket.number"
             >
               <i class="fas fa-save me-1"></i>
               Cadastrar Supermercado
             </button>
           </div>
         </div>
       </div>
     </div>

    <!-- Modal de Detalhes do Supermercado -->
    <div v-if="showDetailsModal" class="modal-backdrop fade show" @click="closeDetailsModal" style="z-index: 9999;"></div>
    <div v-if="showDetailsModal" class="modal fade show d-block" tabindex="-1" aria-labelledby="supermarketDetailsModalLabel" aria-hidden="true" style="z-index: 10000;">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="supermarketDetailsModalLabel">
              <i class="fas fa-info-circle me-2"></i>
              Detalhes do Supermercado
            </h5>
            <button type="button" class="btn-close" @click="closeDetailsModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="loadingDetails" class="text-center py-4">
              <div class="spinner-border spinner-teal" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-2">Carregando detalhes do supermercado...</p>
            </div>
            <div v-else-if="selectedSupermarket" class="row">
              <div class="col-md-6">
                <div class="supermarket-icon-container text-center mb-3">
                  <div class="supermarket-icon-placeholder">
                    <i class="fas fa-store fa-5x text-info"></i>
                    <p class="text-muted mt-2">Supermercado</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="supermarket-details">
                  <h6 class="text-primary mb-3">{{ selectedSupermarket.nome || selectedSupermarket.name || 'Sem nome' }}</h6>
                  
                  <div class="detail-item mb-2">
                    <strong>ID:</strong> {{ selectedSupermarket.id }}
                  </div>
                  
                  <div class="detail-item mb-2" v-if="selectedSupermarket.cnpj || selectedSupermarket.CNPJ">
                    <strong>CNPJ:</strong> {{ selectedSupermarket.cnpj || selectedSupermarket.CNPJ }}
                  </div>
                  
                  <div class="detail-item mb-2">
                    <strong>Status:</strong>
                    <soft-badge 
                      :color="getStatusColor(selectedSupermarket.status || selectedSupermarket.ativo)" 
                      variant="gradient" 
                      size="sm"
                      class="ms-2"
                    >
                      {{ getStatusText(selectedSupermarket.status || selectedSupermarket.ativo) }}
                    </soft-badge>
                  </div>
                  
                  <div class="detail-item mb-2 mt-3">
                    <strong>Endereço:</strong>
                    <div class="mt-1" v-if="loadingDetails">
                      <p class="text-muted">Carregando endereço...</p>
                    </div>
                    <div class="mt-1" v-else-if="addressData">
                      <p class="text-muted mb-1" v-if="addressData.address">
                        <i class="fas fa-map-marker-alt me-1"></i>
                        {{ addressData.address }}, {{ addressData.number || '' }}
                      </p>
                      <p class="text-muted mb-1" v-if="addressData.bairro || addressData.neighborhood">
                        <strong>Bairro:</strong> {{ addressData.bairro || addressData.neighborhood }}
                      </p>
                      <p class="text-muted mb-1" v-if="addressData.cidade || addressData.city">
                        <strong>Cidade:</strong> {{ addressData.cidade || addressData.city }}
                      </p>
                      <p class="text-muted mb-1" v-if="addressData.estado || addressData.state">
                        <strong>Estado:</strong> {{ addressData.estado || addressData.state }}
                      </p>
                      <p class="text-muted mb-1" v-if="addressData.zipcode">
                        <strong>CEP:</strong> {{ addressData.zipcode }}
                      </p>
                      <p class="text-muted mb-0" v-if="addressData.address_line_2">
                        <strong>Complemento:</strong> {{ addressData.address_line_2 }}
                      </p>
                    </div>
                    <div class="mt-1" v-else>
                      <p class="text-muted">Endereço não disponível</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="text-center py-4">
              <div class="alert alert-danger">
                <i class="fas fa-exclamation-triangle me-2"></i>
                Erro ao carregar detalhes do supermercado
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeDetailsModal">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import SoftBadge from "@/components/SoftBadge.vue";
import { API_ENDPOINTS, apiRequest, handleApiResponse } from "@/config/api.js";
import { showSuccessAlert, showErrorAlert, showConfirmAlert } from "@/utils/swal.js";

export default {
  name: "supermercados-table",
  data() {
    return {
      supermercados: [],
      loading: false,
      error: null,
      loadingAddress: false,
      addressData: null,
      addressError: null,
      showModal: false,
      showAddSupermarketModal: false,
      showDetailsModal: false,
      selectedSupermarket: null,
      loadingDetails: false,
      loadingAdd: false,
      addError: null,
      newSupermarket: {
        name: '',
        cnpj: '',
        zipcode: '',
        number: ''
      },
      showEditAddressModal: false,
      editingAddressId: null,
      editAddressMode: 'edit',
      editAddressForm: {
        zipcode: '',
        number: '',
        address_line_2: ''
      },
      loadingEditAddress: false,
      savingAddress: false,
      editAddressError: null
    };
  },
  components: {
    SoftBadge,
  },

  mounted() {
    this.loadSupermercados();
  },
  methods: {
    async loadSupermercados() {
      this.loading = true;
      this.error = null;
      
      try {
        const response = await apiRequest(API_ENDPOINTS.SUPERMARKET, {
          method: 'GET'
        });
        
        const data = await handleApiResponse(response);
        this.supermercados = Array.isArray(data) ? data : (data.data || data.supermercados || []);
        
        console.log('Supermercados carregados:', this.supermercados);
        
      } catch (error) {
        console.error('Erro ao carregar supermercados:', error);
        this.error = error.message || 'Erro ao carregar supermercados';
      } finally {
        this.loading = false;
      }
        },
    
    getStatusColor(status) {
      if (status === true || status === 'ativo' || status === 'active') {
        return 'success';
      } else if (status === false || status === 'inativo' || status === 'inactive') {
        return 'secondary';
      }
      return 'info';
    },
    
    getStatusText(status) {
      if (status === true || status === 'ativo' || status === 'active') {
        return 'Ativo';
      } else if (status === false || status === 'inativo' || status === 'inactive') {
        return 'Inativo';
      }
      return 'Desconhecido';
    },
    
    async viewDetails(supermercado) {
      this.showDetailsModal = true;
      this.selectedSupermarket = supermercado;
      this.loadingDetails = true;
      this.addressData = null;
      this.addressError = null;
      
      try {
        // Busca os detalhes completos do supermercado
        const response = await apiRequest(`${API_ENDPOINTS.SUPERMARKET}/${supermercado.id}`, {
          method: 'GET'
        });
        
        const data = await handleApiResponse(response);
        this.selectedSupermarket = data;
        
        console.log('Detalhes do supermercado carregados:', data);
        
        // Busca o endereço automaticamente
        try {
          const addressResponse = await apiRequest(`${API_ENDPOINTS.SUPERMARKET_ADDRESS}/${supermercado.id}`, {
            method: 'GET'
          });
          
          const addressData = await handleApiResponse(addressResponse);
          this.addressData = addressData;
          
          console.log('Endereço carregado:', addressData);
          
        } catch (addressError) {
          console.error('Erro ao carregar endereço:', addressError);
          // Não bloqueia a exibição dos detalhes se o endereço falhar
          this.addressError = null;
        }
        
      } catch (error) {
        console.error('Erro ao carregar detalhes do supermercado:', error);
        // Se falhar, usa os dados da lista como fallback
        this.selectedSupermarket = supermercado;
      } finally {
        this.loadingDetails = false;
      }
    },
    
    closeDetailsModal() {
      this.showDetailsModal = false;
      this.selectedSupermarket = null;
      this.loadingDetails = false;
      this.addressData = null;
      this.addressError = null;
    },

    async showAddress(supermarketId) {
      this.loadingAddress = true;
      this.addressError = null;
      this.addressData = null;
      this.showModal = true;
      
      try {
                 const response = await apiRequest(`${API_ENDPOINTS.SUPERMARKET_ADDRESS}/${supermarketId}`, {
           method: 'GET'
         });
        
        const data = await handleApiResponse(response);
        this.addressData = data;
        
        console.log('Endereço carregado:', data);
        
      } catch (error) {
        console.error('Erro ao carregar endereço:', error);
        this.addressError = error.message || 'Erro ao carregar endereço';
      } finally {
        this.loadingAddress = false;
      }
    },

    closeModal() {
      this.showModal = false;
      this.addressData = null;
      this.addressError = null;
    },

    async openEditAddressModal(supermercado) {
      this.editingAddressId = supermercado.id;
      this.editAddressError = null;
      this.editAddressMode = 'edit';
      this.editAddressForm = { zipcode: '', number: '', address_line_2: '' };
      this.showEditAddressModal = true;
      this.loadingEditAddress = true;
      try {
        const data = await handleApiResponse(
          await apiRequest(`${API_ENDPOINTS.SUPERMARKET_ADDRESS}/${supermercado.id}`)
        );
        const hasAddress = data && (data.zipcode || data.number || data.address);
        if (hasAddress) {
          this.editAddressMode = 'edit';
          this.editAddressForm.zipcode = data.zipcode || '';
          this.editAddressForm.number = data.number || '';
          this.editAddressForm.address_line_2 = data.address_line_2 || '';
        } else {
          this.editAddressMode = 'create';
        }
      } catch {
        // Endereço não encontrado (ex: 404) — abre para inclusão
        this.editAddressMode = 'create';
      } finally {
        this.loadingEditAddress = false;
      }
    },

    async saveAddress() {
      if (!this.editAddressForm.zipcode || !this.editAddressForm.number) {
        this.editAddressError = 'CEP e Número são obrigatórios';
        return;
      }
      this.savingAddress = true;
      this.editAddressError = null;
      try {
        const isCreate = this.editAddressMode === 'create';
        const url = isCreate
          ? API_ENDPOINTS.SUPERMARKET_ADDRESS
          : `${API_ENDPOINTS.SUPERMARKET_ADDRESS}/${this.editingAddressId}`;
        const payload = {
          zipcode: this.editAddressForm.zipcode,
          number: this.editAddressForm.number,
          address_line_2: this.editAddressForm.address_line_2
        };
        if (isCreate) payload.id_supermarket = this.editingAddressId;

        await handleApiResponse(
          await apiRequest(url, {
            method: isCreate ? 'POST' : 'PUT',
            body: JSON.stringify(payload)
          })
        );
        this.closeEditAddressModal();
        await showSuccessAlert(
          isCreate ? 'Endereço cadastrado!' : 'Endereço atualizado!',
          'O endereço foi salvo com sucesso.'
        );
      } catch (err) {
        this.editAddressError = err.message || 'Erro ao salvar endereço';
      } finally {
        this.savingAddress = false;
      }
    },

    closeEditAddressModal() {
      this.showEditAddressModal = false;
      this.editingAddressId = null;
      this.editAddressMode = 'edit';
      this.editAddressForm = { zipcode: '', number: '', address_line_2: '' };
      this.editAddressError = null;
    },

    showAddModal() {
      this.showAddSupermarketModal = true;
      this.addError = null;
      this.newSupermarket = {
        name: '',
        cnpj: '',
        zipcode: '',
        number: ''
      };
    },

    closeAddModal() {
      this.showAddSupermarketModal = false;
      this.addError = null;
      this.newSupermarket = {
        name: '',
        cnpj: '',
        zipcode: '',
        number: ''
      };
    },

    async addSupermarket() {
      if (!this.newSupermarket.name || !this.newSupermarket.zipcode || !this.newSupermarket.number) {
        this.addError = 'Nome, CEP e Número são obrigatórios';
        return;
      }

      this.loadingAdd = true;
      this.addError = null;

      try {
        // Primeiro, cadastra o supermercado
        const supermarketPayload = {
          name: this.newSupermarket.name,
          cnpj: this.newSupermarket.cnpj
        };

        const supermarketResponse = await apiRequest(API_ENDPOINTS.SUPERMARKET, {
          method: 'POST',
          body: JSON.stringify(supermarketPayload)
        });

        const supermarketData = await handleApiResponse(supermarketResponse);
        const supermarketId = supermarketData.id;

        // Depois, cadastra o endereço
        const addressPayload = {
          id_supermarket: supermarketId,
          zipcode: this.newSupermarket.zipcode,
          number: this.newSupermarket.number
        };

        const addressResponse = await apiRequest(API_ENDPOINTS.SUPERMARKET_ADDRESS, {
          method: 'POST',
          body: JSON.stringify(addressPayload)
        });

        await handleApiResponse(addressResponse);

        // Sucesso! Fecha o modal e recarrega a lista
        this.closeAddModal();
        this.loadSupermercados();
        
        // Mostra mensagem de sucesso com SweetAlert
        await showSuccessAlert(
          'Supermercado cadastrado com sucesso!',
          'O supermercado foi adicionado ao sistema.',
          3000
        );

      } catch (error) {
        console.error('Erro ao cadastrar supermercado:', error);
        this.addError = error.message || 'Erro ao cadastrar supermercado';
      } finally {
        this.loadingAdd = false;
      }
    },

    async deactivateSupermarket(supermercado) {
      // Mostra confirmação antes de desativar
      const result = await showConfirmAlert(
        'Desativar Supermercado',
        `Tem certeza que deseja desativar o supermercado "${supermercado.nome || supermercado.name}"? O supermercado será desativado no sistema.`,
        'Sim, desativar',
        'Cancelar'
      );

      if (!result.isConfirmed) {
        return;
      }

      try {
        // Desativa o supermercado usando DELETE (como em categorias)
        const response = await apiRequest(`${API_ENDPOINTS.SUPERMARKET}/${supermercado.id}`, {
          method: 'DELETE'
        });

        await handleApiResponse(response);

        // Sucesso! Recarrega a lista
        this.loadSupermercados();
        
        // Mostra mensagem de sucesso com SweetAlert
        await showSuccessAlert(
          'Supermercado desativado com sucesso!',
          'O supermercado foi desativado no sistema.',
          3000
        );

      } catch (error) {
        console.error('Erro ao desativar supermercado:', error);
        await showErrorAlert(
          'Erro ao desativar supermercado',
          error.message || 'Não foi possível desativar o supermercado.'
        );
      }
    }
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
}

.modal {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.modal-dialog {
  width: 100%;
  margin: 0.5rem auto;
}

@media (max-width: 576px) {
  .modal-dialog {
    max-width: calc(100% - 1rem);
    margin: 0.5rem;
  }
}

.btn-custom-gradient {
  background: linear-gradient(310deg, #17c1e8 0%, #20c997 100%);
  border: none;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-custom-gradient:hover {
  background: linear-gradient(310deg, #15a8d1 0%, #1bb88a 100%);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(23, 193, 232, 0.3);
}

.btn-custom-gradient:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(23, 193, 232, 0.3);
}

.btn-edit-address {
  background: linear-gradient(310deg, #f5a623 0%, #f76b1c 100%);
  border: none;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-edit-address:hover {
  background: linear-gradient(310deg, #e09520 0%, #e05f18 100%);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(245, 166, 35, 0.3);
}

.btn-edit-address:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(245, 166, 35, 0.3);
}

.btn-address-gradient {
  background: linear-gradient(310deg, #17c1e8 0%, #20c997 100%);
  border: none;
  color: white;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-address-gradient:hover {
  background: linear-gradient(310deg, #15a8d1 0%, #1bb88a 100%);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(23, 193, 232, 0.3);
}

.btn-address-gradient:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(23, 193, 232, 0.3);
}

.btn-address-gradient:disabled {
  background: #6c757d;
  color: #fff;
  opacity: 0.65;
  transform: none;
  box-shadow: none;
}

.spinner-teal {
  color: #20c997 !important;
}

.gap-2 {
  gap: 0.5rem;
}

.text-info:hover,
.text-danger:hover {
  opacity: 0.8;
  transition: opacity 0.2s ease;
  cursor: pointer;
}

.text-info,
.text-danger {
  font-size: 0.875rem;
  transition: all 0.2s ease;
}

.supermarket-icon-placeholder {
  padding: 40px 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 2px dashed #dee2e6;
}

.supermarket-details {
  padding: 0 10px;
}

.detail-item {
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 8px;
}

.detail-item:last-child {
  border-bottom: none;
}

.modal-dialog.modal-lg {
  max-height: 80vh;
}

.modal-dialog.modal-lg .modal-content {
  max-height: 80vh;
  overflow-y: auto;
}

.modal-dialog.modal-lg .modal-body {
  max-height: 60vh;
  overflow-y: auto;
}

</style>
